import { tw } from "@sveabank/cc-common";
import { useLocation } from "react-router";
import { usePages } from "../../hooks/usePages";
import NavigationStep from "./desktop/navStep";

const Navbar = () => {
	const { pages } = usePages();
	const location = useLocation();

	return (
		<nav className="bg-background-primary tablet:flex laptop:w-full relative hidden py-4 text-center">
			<div className="border-interactive-primary tablet:border-y tablet:border-solid absolute inset-x-[40px] top-[36px] z-20 border-none" />
			<div className={tw("flex w-full flex-row justify-between")}>
				{pages.map((page) => (
					<div key={page.url} className="flex grow-0">
						<NavigationStep
							label={page.label}
							url={page.url}
							isActive={location.pathname === page.url}
							isAvailable={page.isAvailable}
							isCompleted={page.isCompleted}
							hasWarning={page.hasWarning}
							locked={page.locked}
							stepNumber={page.stepNumber}
							totalSteps={page.totalSteps}
						/>
					</div>
				))}
			</div>
		</nav>
	);
};

export default Navbar;
